<template>
    <main class="reset-password">
        <div class="page-header">
            <h1 class="page-header__title">Ustaw nowe hasło</h1>
        </div>
        <div class="code">
            <div class="code__desc">
                <div class="form__success" v-if="success">{{ success }}</div>
                <div class="form__error" v-if="error">{{ error }}</div>
                <p>Hasło powinno składać się z przynajmniej 8 znaków</p>
            </div>
            <div class="code__form">
                <div class="code__section">
                    <div class="form__row code__row">
                        <img src="@/assets/svg/lock.svg" alt/>
                        <input
                            type="password"
                            class="code__input"
                            @blur="checkPassword"
                            v-model="password"
                            placeholder="Hasło*"
                        />
                    </div>
                    <div class="form__row code__row">
                        <img src="@/assets/svg/lock.svg" alt/>
                        <input
                            type="password"
                            class="code__input"
                            @blur="checkPasswords"
                            @keydown.enter="handleSubmit"
                            v-model="confirmPassword"
                            placeholder="Powtórz hasło*"
                        />
                    </div>
                    <div class="form__row code__row">
                        <a @click="handleSubmit" :class="submitBtnClass">Resetuj hasło</a>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
    name: "ResetPasswordRequest",
    data() {
        return {
            submitBtnClass: "btn",
            error: "",
            success: "",
            password: "",
            confirmPassword: ""
        };
    },
    computed: mapGetters({
        registrationData: "getRegistrationData"
    }),
    methods: {
        checkPassword() {
            this.error = "";
            (this.password.length < 8)
                ? this.error = "Minimalna długość hasła to 8 znaków"
                : "";
        },
        checkPasswords() {
            this.error = "";
            this.checkPassword();
            !(this.password === this.confirmPassword)
                ? this.error = "Podane hasła muszą być takie same"
                : ''
        },
        handleSubmit(e) {
            e.preventDefault();

            this.checkPasswords();

            if (this.password && this.password === this.confirmPassword && !this.error) {
                this.submitBtnClass = "btn spinner spinner--running";
                axios({
                    method: "post",
                    url: `${process.env.VUE_APP_API_URL}/account/password-change`,
                    headers: {
                        'Content-type': "application/json"
                    },
                    data: {
                        id: this.$route.params.id,
                        password: this.password
                    }
                })
                    .then(() => {
                        this.submitBtnClass = "btn spinner spinner--complete";
                        this.success = "Hasło zostało zmienione!";
                        setTimeout(() => this.$router.push("/zaloguj-sie"), 1000);
                    })
                    .catch(err => {
                        this.submitBtnClass = "btn";
                        this.error = err.response.data.message
                            ? err.response.data.message
                            : "Wystąpił nieznany błąd";
                    });
            }
        }
    }
};
</script>

<style lang="scss">
.reset-password {
    flex: 1;
}
</style>
